export default __webpack_public_path__ + "media/images/features/ja/left_orn-e1e8b1dfde3cc4fd6a935ac8c49451e7.png";